/**
 * Button can be customized with the following metadata properties:
 * - UIAppearance: can be set to 'flat' or 'stroked'
 * - UIColor: can be set to 'primary', 'accent' or 'warn (NOT IMPLEMENTED)
 * - ActionConfirmation: when button is clicked, confirmation dialog is shown
 *
 * Not customized in metadata (but can be added metadata property if needed):
 * - loading starts, when button pressed (without confirmation dialog) or after action is confirmed (with confirmation dialog)
 * */

import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { LoadingActions } from 'src/app/core/store/loading/loading.actions';
import { ProjectDataActions } from 'src/app/project/store/project-data/project-data.actions';
import { EntityPropertyBaseComponent } from '../entity-property-base/entity-property-base.component';

@Component({
  selector: 'app-entity-property-boolean-button',
  templateUrl: './entity-property-boolean-button.component.html',
  styleUrls: ['./entity-property-boolean-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class EntityPropertyBooleanButtonComponent extends EntityPropertyBaseComponent<boolean> {
  constructor(private dialog: MatDialog, private store: Store) {
    super();
  }

  onClick() {
    this.store.dispatch(ProjectDataActions.initialize_action());
    const actionConfirmation = this.propertyType.MetaData['ActionConfirmation'];
    if (actionConfirmation !== undefined) {
      const textId = actionConfirmation;
      const dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { textId } });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          // Start loading before debounce time in entity editor run out
          this.store.dispatch(LoadingActions.loading_start());
          this.propertyForm.setValue(true);
          // Start loading before debounce time in entity editor run out
          this.store.dispatch(LoadingActions.loading_start());
        } else {
          this.store.dispatch(ProjectDataActions.reset_initialize_action());
        }
      });
    } else {
      // Start loading before debounce time in entity editor run out
      this.store.dispatch(LoadingActions.loading_start());
      this.propertyForm.setValue(true);
      // Start loading before debounce time in entity editor run out
      this.store.dispatch(LoadingActions.loading_start());
    }
  }

  getUIAppearance() {
    const uiAppearanceMetadata = this.propertyType.MetaData['UIAppearance'];
    if (uiAppearanceMetadata !== undefined) {
      return uiAppearanceMetadata;
    }
    return 'flat';
  }
}
